import { Outlet, NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

const navItems = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/', label: 'Insert' },
  { to: '/build', label: 'Build' },
  { to: '/zinsser', label: 'Zinsser' },
  { to: '/cards', label: 'Library' },
]

export function AppShell() {
  return (
    <div className="h-dvh flex flex-col bg-background overflow-hidden">
      {/* Header - centered to align with content */}
      <header className="flex-shrink-0 h-14">
        <div className="max-w-6xl mx-auto px-6 md:px-8 h-full flex items-center justify-between">
          {/* Logo / App name - font-light per Zinsser guide */}
          <NavLink to="/" className="group">
            <span className="text-sm font-light tracking-tight text-foreground">
              Card Studio
            </span>
          </NavLink>

          {/* Navigation */}
          <nav className="flex items-center gap-6">
            {navItems.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  cn(
                    'text-sm transition-colors',
                    isActive
                      ? 'text-foreground font-medium'
                      : 'text-muted-foreground font-light hover:text-foreground'
                  )
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  )
}
